import { configureStore } from "@reduxjs/toolkit";
import type { Middleware, Reducer } from "redux";
import rootReducer, { type RootReducerState } from "./rootReducer";

type AsyncReducers = Record<string, Reducer>;
type StoreWithAsyncReducers = typeof store & { asyncReducers: AsyncReducers };

const middlewares: Middleware<unknown, RootReducerState>[] = [];

const store = configureStore({
  reducer: rootReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  devTools: import.meta.env.DEV,
});

export type RootState = RootReducerState;

const typedStore = store as StoreWithAsyncReducers;
typedStore.asyncReducers = {};

export const injectReducer = (key: string, reducer: Reducer) => {
  if (typedStore.asyncReducers[key]) {
    return false;
  }
  typedStore.asyncReducers[key] = reducer;
  typedStore.replaceReducer(rootReducer(typedStore.asyncReducers));
  return typedStore;
};

export default store;
